import React from "react";
import PropTypes from "prop-types";

import ImgBanner from "./ImgBanner";
import ReviewsSlider from "./ReviewsSlider";
import { Container, SliderContainer } from "./styled";

const Reviews = ({ title, coverImg, reviewsData }) => {
  return (
    <Container>
      <ImgBanner title={title} coverImg={coverImg} />
      <SliderContainer>
        <ReviewsSlider reviewsData={reviewsData} />
      </SliderContainer>
    </Container>
  );
};

Reviews.propTypes = {
  title: PropTypes.string,
  coverImg: PropTypes.shape({
    desktop: PropTypes.string,
    ipad: PropTypes.string,
    mobile: PropTypes.string,
  }),
  reviewsData: PropTypes.array,
};

export default Reviews;
